import { render, staticRenderFns } from "./group-savings-pay.vue?vue&type=template&id=584bafdd&scoped=true"
import script from "./group-savings-pay.vue?vue&type=script&lang=js"
export * from "./group-savings-pay.vue?vue&type=script&lang=js"
import style0 from "./group-savings-pay.vue?vue&type=style&index=0&id=584bafdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584bafdd",
  null
  
)

export default component.exports